import React, { Component } from "react";
import {
  Row,
  Col,
  DatePicker,
  Card,
  Radio,
  Icon,
  Button,
  Tag,
  Skeleton,
} from "antd";
import "./dashboard.css";
import OnboardingCircle from "./parts/onboarding-circle";
import VirtualFollowUpCalls from "./parts/virtual-follow-up-calls";
import CalendarInvites from "./parts/calendar-invites";
import Games from "./parts/games";
import RewardSystem from "./parts/ea/reward-system";
import VirtualOnboardStats from "./parts/ea/virtual-onboard-stats";
import BfileStatus from "./parts/ea/bfile-status";
import TotalOpportunitiesUncovered from "./parts/ea/total-opportunities-uncovered";
// import AgencyLifeRetirementActivity from './parts/ea/agency-life-retirement-activity'
import RSCalendarInvites from "./parts/ea/rs-calendar-invites";
import VirtualOnboarderDataSentBackToAgency from "./parts/ea/virtual-onboard-data-sent-back-to-agency";
import moment from "moment";
import axios from "axios";
import { Translate } from "react-translated";
import F from "../../Functions";
import { API_DATE_FORMAT } from "../../utils/Constants";
import Cookies from "js-cookie";

const { RangePicker } = DatePicker;
const today = new Date();

class Dashboard extends Component {
  state = {
    loading: true,
    agencyStatsLoading: false,
    myStatsLoading: false,
    lspStatsLoading: false,
    dashboard: {
      lsp: [],
    },
    period: "all_bfiles",
    start_date: null,
    end_date: null,
    associations: [],
    user: this.props.auth.user,
    vonboard: 0,
    review: 0,
    user_t: "",
    filter_lsp: "",
    internalFilterChange: false,
    has_rs: false,
    agency_id: null,
    // has_efs: false,
  };
  // /api/get_all_reviewscheduler_of_agency
  componentDidMount = () => {
    axios.get("/api/get_all_reviewscheduler_of_agency").then((res) => {
      if (res.data.success) {
        this.setState({ has_rs: true });
      }
    });
    axios.get("/api/get_active_associations").then((res) => {
      // for (let i = 0; i < res.data.length; i++) {
      //   if (res.data[i].user_type === 'EFS') {
      //     this.setState({
      //       has_efs: true,
      //     })
      //   }
      // }
      this.setState({
        associations: res.data,
      });
    });

    // Default Select `All B Files`

    const data = F.getServerDateByType("all_bfiles");

    window.localStorage.user_start_date = data.from;
    window.localStorage.user_end_date = data.to;
    window.localStorage.user_period = "all_bfiles";

    // load stats
    this.loadStats();

    let user_id = this.state.user.id;
    axios.get("/api/users/" + user_id).then((res) => {
      let agency_id = null;
      if (
        res.data.user_agency_assoc &&
        res.data.user_agency_assoc.length > 0
      ) {
        agency_id = res.data.user_agency_assoc[0].agency_id || null;
      }
      axios.get("/api/agencies/" + agency_id).then((res) => {
        this.setState({
          vonboard: res.data.vonboard,
          review: res.data.review,
          agency_id,
        });
      });
    });
  };
  changePeriod = (e) => {
    const value = e.target.value;

    const data = F.getServerDateByType(value);

    // start date
    let start_date = data.from;

    // end date
    let end_date = data.to;

    window.localStorage.user_start_date = start_date;
    window.localStorage.user_end_date = end_date;
    window.localStorage.user_period = value;

    this.setState(
      {
        start_date: start_date,
        end_date: end_date,
        period: value,
      },
      () => {
        this.loadStats();
      }
    );
  };
  onChangeDateRange = (date, dateString) => {
    let start_date = null;
    let end_date = null;
    let period = null;

    // Check If User pressed on `crossed` icon `Reset to Monthly View`
    if (dateString[0].length === 0 && dateString[1].length === 0) {
      start_date = moment(
        new Date(today.getFullYear(), today.getMonth(), 1)
      ).format("YYYY-MM-DD");

      // end date
      end_date = moment(
        new Date(today.getFullYear(), today.getMonth() + 1, 0)
      ).format("YYYY-MM-DD");

      period = "mtd";
    } else {
      start_date = dateString[0];
      end_date = dateString[1];
      period = "from_to";
    }

    window.localStorage.user_start_date = start_date;
    window.localStorage.user_end_date = end_date;
    window.localStorage.user_period = period;

    this.setState(
      {
        start_date,
        end_date,
        period,
      },
      () => {
        F.log("loadStats calling 8");
        this.loadStats();
      }
    );
  };
  refresh = () => {
    this.setState({ loading: true });
    axios.get("/api/delete_user_cache").then((res) => {
      this.setState({
        loading: false,
        period: "all_bfiles",
        start_date: null,
        end_date: null,
      });

      F.log("loadStats calling 9");
      this.loadStats();
    });
  };
  loadStats = () => {
    const { period, start_date, end_date } = this.state;
    let data = { window: period };

    if (start_date != null && end_date != null) {
      data.from = start_date;
      data.to = end_date;
    }

    if (period != null && period != "from_to") {
      const datesData = F.getServerDateByType(period);
      data.from = datesData.from;
      data.to = datesData.to;
    }

    this.setState({
      loading: true,
      agencyStatsLoading: true,
      myStatsLoading: true,
      lspStatsLoading: true,
      dashboard: {
        lsp: [],
      },
    });
    // axios.post('/api/dash_stats', data).then((res) => {
    //   const dashboard = res.data

    //   dashboard.lsp = [
    //     {
    //       user: this.props.auth.user,
    //       stats: dashboard.stats,
    //     },
    //   ].concat(dashboard.lsp)

    //   this.setState({
    //     loading: false,
    //     dashboard,
    //   })
    // })

    // Get Agency Stats
    axios
      .post("/api/dash_stats_agency_stats", data)
      .then((res) => {
        this.setState((prevState) => {
          const dashboard = { ...prevState.dashboard };
          dashboard.agency_stats = res.data.agency_stats;

          return {
            loading: false,
            agencyStatsLoading: false,
            dashboard,
          };
        });
      })
      .catch((error) => {
        this.setState({
          loading: false,
          agencyStatsLoading: false,
        });
      });

    // Get my Stats
    axios
      .post("/api/dash_stats_stats", data)
      .then((res) => {
        this.setState((prevState) => {
          const dashboard = { ...prevState.dashboard };
          dashboard.stats = res.data.stats;

          const myUserStats = {
            user: this.props.auth.user,
            stats: res.data.stats,
          };

          dashboard.lsp = [myUserStats].concat(dashboard.lsp);

          return {
            loading: false,
            myStatsLoading: false,
            dashboard,
          };
        });
      })
      .catch((error) => {
        this.setState({
          loading: false,
          myStatsLoading: false,
        });
      });

    // Get LSP Stats
    axios
      .post("/api/dash_stats_lsp_stats", data)
      .then((res) => {
        this.setState((prevState) => {
          const dashboard = { ...prevState.dashboard };
          dashboard.lsp = dashboard.lsp.concat(res.data.lsp);

          return {
            loading: false,
            lspStatsLoading: false,
            dashboard,
          };
        });
      })
      .catch((error) => {
        this.setState({
          loading: false,
          lspStatsLoading: false,
        });
      });
  };

  render() {
    const {
      dashboard,
      associations,
      loading,
      agencyStatsLoading,
      myStatsLoading,
      lspStatsLoading,
      start_date,
      end_date,
      period,
      filter_lsp,
    } = this.state;
    const dateFormat = "YYYY-MM-DD";
    const user = this.props.auth.user;

    let defaultFromDate = new Date("2010-01-01");

    if (start_date) defaultFromDate = new Date(start_date);

    let defaultToDate = new Date("2050-01-01");
    if (end_date) defaultToDate = new Date(end_date);

    let user_type = user.user_type;
    if (user.user_type === "EA") user_type = "Agency Owner";
    if (user.user_type === "LSP") user_type = "Agency Member";

    F.log("user_type ==>> " + user_type);

    // check dashboard has all needed response
    const isDashboardHasData =
      dashboard.hasOwnProperty("agency_stats") &&
      dashboard.hasOwnProperty("stats");

    return (
      <div id="ea-dashboard">
        <div className="topbar">
          <Card bordered={false}>
            <Row gutter={16} type="flex" justify="space-around" align="middle">
              <Col md={8} span={24}>
                <div className="username">
                  <Icon type="user" />
                  {user.first_name + " " + user.last_name}{" "}
                  <Tag color="blue">{user_type}</Tag>
                </div>
              </Col>
              <Col md={16} span={24}>
                <div
                  className="right-align"
                  style={{ marginTop: -5, marginBottom: -5 }}
                >
                  <div className="inlineField">
                    <Radio.Group
                      value={filter_lsp}
                      onChange={(e) => {
                        this.setState({
                          user_t: e.target.value,
                          filter_lsp: e.target.value,
                          internalFilterChange: false,
                        });
                      }}
                    >
                      <Radio.Button value={user.id}>My Stats</Radio.Button>
                      <Radio.Button value={""}>Agency Stats</Radio.Button>
                    </Radio.Group>
                  </div>
                  <div className="separator inlineField" />
                  <div className="inlineField">
                    <Button icon="reload" onClick={this.refresh.bind(this)}>
                      {" "}
                      <Translate text={`Refresh`} />
                    </Button>
                  </div>
                  <div className="inlineField">
                    <Radio.Group
                      value={period}
                      onChange={this.changePeriod.bind(this)}
                      style={{ width: "100%" }}
                    >
                      <Radio.Button value="mtd">
                        <Translate text={`This Month`} />
                      </Radio.Button>
                      <Radio.Button value="ytd">
                        <Translate text={`This Year`} />
                      </Radio.Button>
                      <Radio.Button value="all_bfiles">
                        <Translate text={`All B Files`} />
                      </Radio.Button>
                    </Radio.Group>
                  </div>
                  <div className="inlineField">
                    <RangePicker
                      value={[moment(defaultFromDate), moment(defaultToDate)]}
                      onChange={this.onChangeDateRange}
                      format={dateFormat}
                      style={{ maxWidth: 280 }}
                    />
                  </div>
                </div>
              </Col>
            </Row>
          </Card>
        </div>

        {isDashboardHasData && !loading ? (
          <Row type="flex" gutter={16}>
            <Col lg={{ span: 18, order: 0 }} span={24} xs={{ order: 1 }}>
              <TotalOpportunitiesUncovered
                dashboard={dashboard}
                associations={associations}
                loading={
                  agencyStatsLoading || myStatsLoading || lspStatsLoading
                }
                user={user}
                history={this.props.history}
                start_date={start_date}
                end_date={end_date}
                period={period}
                vonboard={this.state.vonboard}
                // user_t={this.state.user_t}
                filter_lsp={this.state.filter_lsp}
                internalFilterChange={this.state.internalFilterChange}
                setInternalFilterChange={(state) =>
                  this.setState({ internalFilterChange: state })
                }
              />
              <BfileStatus
                dashboard={dashboard}
                associations={associations}
                loading={
                  agencyStatsLoading || myStatsLoading || lspStatsLoading
                }
                user={user}
                history={this.props.history}
                start_date={start_date}
                end_date={end_date}
                period={period}
                vonboard={this.state.vonboard}
                // user_t={this.state.user_t}
                filter_lsp={this.state.filter_lsp}
                internalFilterChange={this.state.internalFilterChange}
                setInternalFilterChange={(state) =>
                  this.setState({ internalFilterChange: state })
                }
              />
              {this.state.vonboard ? (
                <VirtualOnboardStats
                  start_date={start_date}
                  end_date={end_date}
                  period={period}
                  user={user}
                  history={this.props.history}
                  agency_id={this.state.agency_id}
                // user_t={this.state.user_t}
                />
              ) : (
                <React.Fragment></React.Fragment>
              )}
              {/* {this.state.has_efs && (
                <AgencyLifeRetirementActivity
                  dashboard={dashboard}
                  associations={associations}
                  loading={loading}
                  user={user}
                  start_date={start_date}
                  end_date={end_date}
                  period={period}
                  filter_efs={this.state.filter_lsp}
                  internalFilterChange={this.state.internalFilterChange}
                  setInternalFilterChange={(state) =>
                    this.setState({ internalFilterChange: state })
                  }
                />
              )} */}

              {this.state.vonboard ? (
                <VirtualOnboarderDataSentBackToAgency
                  dashboard={dashboard}
                  associations={associations}
                  loading={
                    agencyStatsLoading || myStatsLoading || lspStatsLoading
                  }
                  loadStats={this.loadStats}
                  user={user}
                  history={this.props.history}
                  start_date={start_date}
                  end_date={end_date}
                  period={period}
                  // user_t={this.state.user_t}
                  filter_lsp={this.state.filter_lsp}
                  internalFilterChange={this.state.internalFilterChange}
                  setInternalFilterChange={(state) =>
                    this.setState({ internalFilterChange: state })
                  }
                  vonboard={this.state.vonboard}
                  review={this.state.review}
                />
              ) : (
                <React.Fragment></React.Fragment>
              )}
              {this.state.review ? (
                <RSCalendarInvites
                  dashboard={dashboard}
                  associations={associations}
                  loading={
                    agencyStatsLoading || myStatsLoading || lspStatsLoading
                  }
                  loadStats={this.loadStats}
                  user={user}
                  history={this.props.history}
                  start_date={start_date}
                  end_date={end_date}
                  period={period}
                  // user_t={this.state.user_t}
                  filter_lsp={this.state.filter_lsp}
                  internalFilterChange={this.state.internalFilterChange}
                  setInternalFilterChange={(state) =>
                    this.setState({ internalFilterChange: state })
                  }
                  vonboard={this.state.vonboard}
                  review={this.state.review}
                />
              ) : (
                <React.Fragment></React.Fragment>
              )}
            </Col>

            <Col lg={{ span: 6, order: 1 }} span={24} xs={{ order: 0 }}>
              <OnboardingCircle
                dashboard={dashboard}
                loading={
                  agencyStatsLoading || myStatsLoading || lspStatsLoading
                }
                history={this.props.history}
                user={user}
                start_date={start_date}
                end_date={end_date}
                period={period}
                vonboard={this.state.vonboard}
              />

              {/* <VirtualFollowUpCalls
                dashboard={dashboard}
                loading={
                  agencyStatsLoading || myStatsLoading || lspStatsLoading
                }
                user={user}
                start_date={start_date}
                end_date={end_date}
                period={period}
              /> */}

              {/* {this.state.has_rs && <CalendarInvites />} */}
              <RewardSystem />
              <Games
                dashboard={dashboard}
                start_date={start_date || defaultFromDate}
                end_date={end_date || defaultToDate}
                period={period}
              />
            </Col>
          </Row>
        ) : (
          <div
            style={{
              background: "#FFF",
              padding: 20,
            }}
          >
            <Skeleton active />
          </div>
        )}
      </div>
    );
  }
}

export default Dashboard;



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/ea.js